<template>
<div class="row" style="max-width: 1875px;">
  <div class="col-10 ms-auto" >
    <h3 style="margin-top: 50px;" class="page-title">GENDEC</h3>
    <div class="employee-status alert" role="alert">
    </div>
    
    <div v-permcheck="'Gendec.ReportGrid.R'" class="buttons-area row" style="width: 1200px"  >
      <div class="text-end d-flex justify-content-between">
        <div class="date-picker-area me-3"><input id="date-picker" @change="datePickerChanged" v-model="picked" class="p-2" type="date"></div>
        <div>
          <router-link tag="button" to="/DAI-Gendec/gendec-rules" class="core-save-btn rounded-1" style="line-height: 2">
            <span class="card-title">Gendec Rules <i class="icon icon-cog ms-2"></i></span>
        </router-link></div>
      </div>
    </div>
    <div class="custom-loader d-none"></div>
    
    <table v-permcheck="'Gendec.ReportGrid.R'" border="1" class="table table-bordered table-scroll core-table table-hover flight-information"    style="width: 1200px">
        <thead>
        <th>Registration</th>
        <th>Flight No</th>
        <th>Dep</th>
        <th>Arr</th>
        <th>STD</th>
        <th>STA</th>
        <th>ATD</th>
        <th>ATA</th>
        <th>Sending Time</th>
        <th>Sent Time</th>
        <th>Mail Status</th>
        <th>Error Messages</th>
        </thead>
        <tbody class="flight-details">
          <tr v-for="(item,index) in this.flightList" style="height: 50px; cursor: pointer" @click="getList(item.LEGNO)" :key="index" :id="item.LEGNO">
        <td>{{item.AC_REG}}</td>
        <td>{{item.CARRIER}}-{{item.FNO}}</td>
        <td>{{item.DEP}}</td>
        <td>{{item.ARR}}</td>
        <td>{{splitDate(item.STD).formatted_dateHHMM}}</td>
        <td>{{splitDate(item.STA).formatted_dateHHMM}}</td>
        <td>{{splitDate(item.ATD).formatted_dateHHMM}}</td>
        <td>{{splitDate(item.ATA).formatted_dateHHMM}}</td>
        <td>{{ splitDate(item.MAIL_SENDABLEDT).formatted_dateHHMM }}</td>
        <td>{{splitDate(item.MAIL_SENDDT).formatted_dateHHMM}}</td>
        <td :style="item.MAIL_STATUS === 0 ? '' : item.MAIL_STATUS === 1 ? 'background: lightgreen' : 'background: #d51317'">{{item.MAIL_STATUS === 0 ? "Waiting" : item.MAIL_STATUS === 1 ? "Success" : "Error"}}</td>
        <td><button v-if="item.MAIL_ERRORS !== '' && item.MAIL_ERRORS" type="button" class="core-update-btn rounded-1" data-bs-toggle="tooltip" data-bs-placement="top" :title="item.MAIL_ERRORS">
          <i class="icon icon-notification" style="font-size: 18px"></i>
        </button></td>
      </tr>
        </tbody>

    </table>
    <div class="buttons-area row justify-content-start" >
      
      <div v-permcheck="'Gendec.ReportGrid.W'" class="col-md-4 text-end d-flex justify-content-start">
        <!--      <button class="btn btn-success mb-1 ms-3" @click="Export_TableToExcel()">Export To Excel <i class="icon icon-download-solid"></i></button>-->
       
        <button  class="core-save-btn mb-1 ms-3 rounded-1"   @click="SendMail()">Send Mail <i class="icon icon-folder-upload"></i></button>
        <button  class="core-add-btn mb-1 ms-3 rounded-1" :style="!getData.length ? 'pointer-events: none; opacity: .5' : ''"  @click="downloadPDF()">Export to PDF <i class="icon icon-file-pdf-solid"></i></button>
      </div>
    </div>

  </div>
  
 <div v-permcheck="'Gendec.ReportGrid.R'" class="col-12 ms-4" id="pdf-area">
   <table class="table table-striped" border="2" id="gendec-table" style="width: 1800px; font-size: 13px; margin-bottom: 10px">
    <tbody>
      <tr>
       <td>
        <img v-if="!isEgypt && !isIndia && !isCnd" style="width: 120px;" src="../../../src/assets/corendon_airlines.png" alt="">
        <img v-if="isIndia && !isEgypt" style="width: 120px;" src="../../../src/assets/SpiceJet.png" alt="">
        <img v-if="isEgypt && !isIndia" style="width: 120px;" src="../../../src/assets/red_sea.png" alt="">
         <img v-if="isCnd" style="width: 120px; margin-top: 5px" src="../../../src/assets/corendon-logo.png" alt="">
      </td>
       <td colspan="2"><strong>Genaral Declaration</strong><br>Outward/Inward</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td colspan="3"></td>
       
     </tr>
     <tr style="border-bottom: 3px solid black">
       <td>ICAO ANNEX 9<br>APPENDIX 1</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td colspan="3"></td>
     </tr>
     <tr>
       <td>Owner or Operator : <strong>CORENDON AIRLINES</strong></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td colspan="3">Date : <strong>{{this.Date}}</strong></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td>Marks of nationality and Registriation : <strong>{{Ac_Reg}}</strong> </td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td colspan="3">Flight No : <strong>{{CARRIER}}-{{FNO}}</strong></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td>AcType : <strong>{{Ac_Type}}</strong></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>

       <td></td>

       <td></td>
       <td></td>

       <td></td>
       <td colspan="3"></td>
     </tr>
     <tr style="border-bottom: 3px solid black">
       <td>Departure From : <strong>{{DEP}} {{DEPARTURE}}</strong></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td colspan="3">Arrival At : <strong>{{ARR}} {{ARRIVAL}}</strong></td>
       <td></td>
       <td colspan="3"></td>
     </tr>
     <tr>
       <td>PLACE</td>
       <td>TOTAL NUMBER OF CREW</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td>NUMBER OF PASSENGERS ON THIS STAGE</td>
       <td></td>
       <td colspan="3">  </td>
     </tr>
     <tr>
       <td></td>
       <td>(To be completed only when required by the state)</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td>(To be completed only when required by the state Not to be completed when pasenger manifest are presented)</td>
       <td></td>
       <td colspan="3"></td>
     </tr>
    </tbody>
     
   </table>

   <table border="2" class="table table-striped employee-information" style="width: 1800px; margin-bottom: 10px; font-size: 13px">
    <thead>
      <tr style="border-bottom: 3px solid black; border-top: 3px solid black; vertical-align: middle;">
       <td></td>
       <td>Cat</td>
       <td>Surname</td>
       <td>Name</td>
       <td v-if="isEmpNeed">EmpID</td>
       <td>Signature</td>
       <td colspan="2">Date of Birth</td>
       <td>Passport</td>
       <td colspan="2">Date of Expiry</td>
       <td style="text-align: center">Gender</td>
       <td>Nat.</td>
     </tr>
    </thead>
<tbody class="employee-details">
  <tr v-for="(item, index) in getData" :key="index">
       <td>{{DEP}}-{{ARR}}</td>
       <td>{{ item.CAT }}</td>
       <td>{{item.SURNAME}}</td>
       <td>{{item.CNAME}}</td>
       <td v-if="isEmpNeed">{{ item.NefaEmployeeId }}</td> 
       <td></td>
       <td colspan="2">{{splitDate(item.DATE_BIRTH).formatted_Gendec}}</td>
       <td>{{item.PASSPORT !== "" && item.PASSPORT !== undefined ? item.PASSPORT.replaceAll('|', '') : ''}}</td>
       <td colspan="2">{{item.DATE_EXPIRY && item.DATE_EXPIRY !== "" ? item.DATE_EXPIRY.replaceAll("|","").substring(0,11) : item.HR_DATE_EXPIRY && item.HR_DATE_EXPIRY !== "" ? new Date(item.HR_DATE_EXPIRY).toString().substring(4,15) : ""}}</td>
       <td style="text-align: center">{{item.GENDER === 'E' ? 'M' : item.GENDER === 'M' ? 'M' : 'F'}}</td>
       <td>{{item.NAT}}</td>
       <td></td>
     </tr>
</tbody>
<tfoot>
      <tr>
       <td>{{DEP}}-{{ARR}}</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     </tfoot>
   </table>

   <table border="2" class="table table-striped" style="width: 1800px">
    <tbody>
      <tr style="border-top: 3px solid black;">
       <td style="font-weight: bold; font-size: 14px">DECLERATION OF HEALTH</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td style="font-weight: bold; font-size: 14px;">FOR OFFICIAL USE ONLY</td>
     </tr>
     <tr>
       <td>Name and seat number of function of pesongers onbaord with illnesses other than airsickness or the effects</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td> of accidents , who may be suffering from a communicable disease (A fever-temperature 38 degress c/100 </td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td>degrees F or greater - associated with one or more of the following signs or symptoms, e.g. Appearing obviosly </td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td>unwell, persistent couhhing, impaired breathing, perisistent diarhea, persistent vomiting, skin rash,bruising </td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td>or bleeding without previous injury, or confusion of recent onset.increases the likelihood that the person is</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr style="border-bottom: 3px solid black;">
       <td>suffering a communicable disase) as well as such cases of illness disembarked during a previous stop</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr style="border-top: 3px solid black; border-bottom: 3px solid black;">
       <td>Any other conditions on board which may lead to the spread of disease ……………………</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr style="border-top: 3px solid black;">
       <td>Details of each disinsecting or sanitary traetment ( place , date , time , method ) during</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td>the flight , if no disinsecting has been carried out during the flight , give details of most</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td>recent disinsecting …………………………………………………………………………………….</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr style="border-top: 3px solid black;">
       <td style="font-weight: bold; font-size: 14px;"> Signed , if required ……………………………………………………………………………………</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr style="border-bottom: 3px solid black">
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td>Crew member concerned</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td>I declare that all statements and particulars contained in this General Declaration and in any supplementary forms required to be presented</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td>with this General Declaration are complete , exact and true to the best of my knowledge and that all through passengers will continue / have</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td></td>
       <td></td>
       <td style="font-weight: bold; font-size: 14px;"> Signature …………………………………………………………..</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td>Authorized agent or pilot in command</td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
       <td></td>
     </tr>
     <tr style="border-top: 3px solid black; border-bottom: 3px solid black">
       <td style="font-weight: bold; font-size: 14px;">Remarks</td>
       <td colspan="11"></td>
     </tr>
    </tbody>

   </table>


 </div>

</div>
</template>

<script>
import axios from "axios";
import {GlobalFunctionAndStateMixin} from "../../utils/mixins.js";
export default {
  mixins: [GlobalFunctionAndStateMixin],
  name: "GendecPage",
  data(){
    return {
      getData: [],
      Ac_Reg : '',
      Date: '',
      FNO: '',
      CARRIER: '',
      Ac_Type: '',
      REVNO: '',
      DEP: '',
      ARR: '',
      DEPARTURE: '',
      ARRIVAL: '',
      picked: '',
      flightList: [],
      selectedLEGNO: '',
      isEmpNeed: false,
      isIndia : false,
      isEgypt: false,
      isCorendon: false,
      isCnd: false
    }
  },
  mounted() {
    this.dateFormatter();
    this.getFlightList();
  },
  methods: {
    downloadPDF () {
      axios.get(process.env.VUE_APP_API_URL+"DAI/Gendec/download", {
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = this.picked.toString() + "_" + this.DEP + "-" + this.ARR + "_Gendec.pdf";
        a.click();
      });
    },
    SendMail(){
      let userName = JSON.parse(localStorage.getItem("user")).name;
      let element = document.getElementsByClassName("employee-status")[0];
      axios.get(process.env.VUE_APP_API_URL+"DAI/Gendec/SendMail", { params: { FDay: this.picked, LegNo: this.selectedLEGNO, username: userName } })
          .then((response) => {
            //console.log(response);
            if(response.request.status === 200){
              element.classList.add('alert-success');
              element.innerHTML = "Mail successfully sent !";
              element.classList.add('alert-block');
              this.getFlightList();
            }
            else {
              element.classList.add('alert-danger');
              element.innerHTML = "Error on sending email !";
              element.classList.add('alert-block');
            }
          })
    },
    getFlightList(){
      let element = document.getElementsByClassName("employee-status")[0];
      this.flightList = [];
      axios.get(process.env.VUE_APP_API_URL+'DAI/Gendec/GetFlightList?FDAY='+this.picked)
          .then((response) => {
            console.log(response)
            this.flightList = JSON.parse(response.data.jsondata);
            //this.flightList = this.flightList.filter(x=>x.DEP_C === 'RU' || x.ARR_C === 'RU');
          })
          .catch(reason => {
            console.log(reason);
          })
      setTimeout(function() {
        element.classList.remove('alert-block');
        element.classList.remove('alert-success');
        element.classList.remove('alert-danger');
      }, 2500)
    },
    getList(id) {
      try {
        console.log(id);
        if(this.selectedLEGNO !== '' && this.selectedLEGNO !== undefined && document.getElementById(this.selectedLEGNO)){
          let selectedRow = document.getElementById(this.selectedLEGNO);
          selectedRow.style.backgroundColor = 'unset';
          selectedRow.style.color = 'unset';
        }
        this.selectedLEGNO = id;
        let element = document.getElementById(id);
        if(id){
          element.style.backgroundColor = '#d51317';
          element.style.color = 'white';
        }
        let table = document.getElementsByTagName("table")[0];
        let loader = document.getElementsByClassName('custom-loader')[0];
        table.style.opacity = '.2';
        loader.classList.remove('d-none');
        loader.classList.add('d-block');
        this.getData = [];
        axios.get(process.env.VUE_APP_API_URL+'DAI/Gendec/GetByLegNo/'+ this.picked + "/"+ this.selectedLEGNO)
            .then((response) => {
              //console.log(response);
              this.getData = JSON.parse(response.data.jsondata);
              console.log(this.getData);
              this.Ac_Reg = this.getData[0].AC_REG;
              //console.log(this.getData[0].FDATE)
              this.Date   = this.splitDate(this.getData[0].FDATE).formatted_date
              this.FNO = this.getData[0].FNO;
              this.CARRIER = this.getData[0].CARRIER;
              this.Ac_Type = this.getData[0].AC_TYPE;
              this.REVNO = this.getData[0].REVNO;
              this.DEP = this.getData[0].DEP;
              this.ARR = this.getData[0].ARR;
              this.DEPARTURE = this.getData[0].DEPARTURE;
              this.ARRIVAL = this.getData[0].ARRIVAL;
              this.isEmpNeed = this.getData[0].DEP_COUNTRY === 'IN' || this.getData[0].ARR_COUNTRY === 'IN';
              this.isIndia = this.getData[0].DEP_COUNTRY === 'IN' || this.getData[0].ARR_COUNTRY === 'IN';
              this.isCnd = this.getData[0].CARRIER.trim() === 'CND';
              console.log(this.getData[0].DEP_COUNTRY);
              console.log(this.getData[0].ARR_COUNTRY);
              console.log(this.isEmpNeed);
              console.log("is CND",this.isCnd);
              this.getData.map(x=>x.CAT === 0 ? x.CAT = 'CPT' : x.CAT === 1 ? x.CAT = 'FO' : x.CAT === 5 ? x.CAT = 'PU' : x.CAT === 6 ?  x.CAT = 'CA' : x.CAT === 7 ? x.CAT = 'JU' : x.ISTECHNIC ? x.CAT = 'TEC' : x.CAT = '');
            });
        //this.selectedLEGNO = '';

        setTimeout( () => {
          table.style.opacity = '1';
          loader.classList.remove('d-block');
          loader.classList.add('d-none');
        }, 2500)
      }
      catch (e) {
        console.log(e)
      }
    },
    datePickerChanged(){
      this.getFlightList();
    },
    dateFormatter() {
      let date = (document.getElementById('date-picker').value);
      if (date.length < 5) {
        date = new Date().toLocaleDateString('es-CL');
      }
      let year = date.slice(6, 10);
      let month = date.slice(3, 5);
      let day = date.slice(0, 2);

      this.picked = year + "-" + month + "-" + day;
    },
  }
}
</script>

<style scoped>
table{
  margin-top: 15px;
  margin-bottom: 150px;
}
tr{
  height: 50px;
}
.alert{
  display: none;
  position: fixed;
  top: 20px;
  right: 20px;
}
.alert-block{
  display: block;
  transition: all 2s linear;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}

.custom-loader {
  width:50px;
  height:50px;
  border-radius:50%;
  background:conic-gradient(#0000 10%,#d51317);
  -webkit-mask:radial-gradient(farthest-side,#d51317 calc(100% - 8px),#d51317 0);
  animation:s3 1s infinite linear;
  position: relative;
  top: 250px;
  left: 600px;
}
@keyframes s3 {to{transform: rotate(1turn)}}


#date-picker{
  font-size: 16px;
}

.core-update-btn:hover{
  background-color: #d96b1f !important;
}
</style>
